import React from "react";
import styles from "../boatInfo.module.css";
import useChapterActionIdMatch from "../../../../hooks/useChapterActionIdMatch";

function AddButton({ mode, option, handle, action }) {
  const access = useChapterActionIdMatch(action);

  return (
    <>
      {mode === "edit" && option.addNote && access && (
        <button
          className={`${styles["add-buttons"]}`}
          data-event={"add"}
          id={option.keyTable}
          type="button"
          onClick={(e) => {
            handle(e, option.keyTable);
          }}>
          <span className={styles["plus-icon"]}></span>
          <span>{"Добавить"}</span>
        </button>
      )}
    </>
  );
}

export default AddButton;
